import React, { useEffect, useState, useContext } from "react";

import Typography from "@material-ui/core/Typography";
import CircularProgress from "@material-ui/core/CircularProgress";
import VisibilityIcon from "@material-ui/icons/Visibility";
import {
  Container,
  Button,
  Menu,
  MenuItem,
  InputAdornment,
  Input,
  Card,
  ListItem,
  TextField,
  Badge,
  Tabs,
  Tab,
  Select,
  FormControl,
  Checkbox,
  FormControlLabel,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  TableContainer,
  Paper,
  TableSortLabel,
  withStyles,
} from "@material-ui/core";
import OwnerHeader from "../Components/OwnerHeader";
import CustomSnakBar from "../../../Components/CustomSnakBar";
import { Link, useHistory, useLocation, useParams } from "react-router-dom";
import GlobalContext from "../../../Context/globalContext";
import Chip from "@material-ui/core/Chip";
import { KeyboardDatePicker } from "@material-ui/pickers";
import { Autocomplete } from "@material-ui/lab";
import moment from "moment";

import SearchIcon from "@material-ui/icons/Search";
import StorefrontIcon from "@material-ui/icons/Storefront";
import SaveAltIcon from "@material-ui/icons/SaveAlt";
import FilterListIcon from "@material-ui/icons/FilterList";
import ClearIcon from "@material-ui/icons/Clear";

import { Instance } from "../../../Config";
import {
  INIT_ORDER,
  LOAD_ORDER,
  SHOW_SNACKBAR,
} from "../../../Context/globalActions.types";

import jsPDF from "jspdf";
import "jspdf-autotable";
import { CSVLink } from "react-csv";
import useSWR from "swr";
import { Skeleton } from "@material-ui/lab";
import InsertDriveFileOutlinedIcon from "@material-ui/icons/InsertDriveFileOutlined";
import {
  generateMultiOrderHtml,
  exportOrdersPdf,
  exportOrderPdf,
} from "../../../utils/orderPdfUtils";

// Styled components for table
const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(even)": {
      backgroundColor: theme.palette.action.hover,
    },
    "&:hover": {
      backgroundColor: "#F3F3F3",
      transform: "scale(1.0019)",
    },
  },
}))(TableRow);

const OwnerViewOrders = () => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [nextPage, setNextPage] = useState(undefined);
  const [previousPage, setPreviousPage] = useState(undefined);
  const [totalItems, setTotalItems] = useState(0);

  const [search, setSearch] = useState("");

  const [rows, setRows] = useState([]);
  const history = useHistory();
  const params = useParams();

  const { globalContext, dispatch } = useContext(GlobalContext);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open1 = Boolean(anchorEl);
  const id = open1 ? "simple-popover" : undefined;

  // Tab state
  const [currentTab, setCurrentTab] = useState(0);

  // Items view states
  const [itemsData, setItemsData] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectAllItems, setSelectAllItems] = useState(false);
  const [itemsPage, setItemsPage] = useState(0);
  const [itemsPerPage] = useState(25);
  const [displayedItems, setDisplayedItems] = useState([]);
  const [isUpdatingStatus, setIsUpdatingStatus] = useState(false);
  const [updatingItemId, setUpdatingItemId] = useState(null);

  // Order selection states (for multi-order PDF export)
  const [selectedOrders, setSelectedOrders] = useState([]);
  const [selectAllOrders, setSelectAllOrders] = useState(false);

  // Filter states
  const [showFilters, setShowFilters] = useState(false);
  const [salesmanCd, setSalesmanCd] = useState("");
  const [distributorCd, setDistributorCd] = useState("");
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [salesmanList, setSalesmanList] = useState([]);
  const [distributorList, setDistributorList] = useState([]);

  const location = useLocation();
  function getQueryVariable(variable) {
    var query = location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      if (decodeURIComponent(pair[0]) == variable) {
        return decodeURIComponent(pair[1]);
      }
    }
  }

  // Fetch salesman filter options
  const { data: resSalesmanData, error: resSalesmanDataError } = useSWR(
    `/orders/filter-options/salesmen?mobileNo=${params.mobileNo}`,
  );

  // Fetch distributor filter options
  const { data: resDistributorData, error: resDistributorDataError } = useSWR(
    `/orders/filter-options/distributors?mobileNo=${params.mobileNo}`,
  );

  useEffect(() => {
    if (resSalesmanData) {
      setSalesmanList(resSalesmanData.data.result || []);
    }
  }, [resSalesmanData]);

  useEffect(() => {
    if (resDistributorData) {
      setDistributorList(resDistributorData.data.result || []);
    }
  }, [resDistributorData]);

  useEffect(() => {
    if (resSalesmanDataError || resDistributorDataError) {
      dispatch({
        type: SHOW_SNACKBAR,
        payload: {
          message: "Failed to load filter options",
          type: "error",
        },
      });
    }
  }, [resSalesmanDataError, resDistributorDataError]);

  const handleSearch = (search) => {
    if (search != "") {
      setRows([]);
      Instance.get(`/orders?mobileNo=${params.mobileNo}&query=${search}`)
        .then((res) => {
          if (res.status == 200) {
            setRows(res.data.result);
            dispatch({
              type: INIT_ORDER,
              payload: res.data.result,
            });
          }
        })
        .catch((e) => {
          dispatch({
            type: SHOW_SNACKBAR,
            payload: {
              message: e.response.message || "Something went wrong",
              type: "error",
            },
          });
        });
    } else {
      setPage(0);
      Instance.get(
        `/orders?mobileNo=${params.mobileNo}&per_page=${rowsPerPage}&page=${page}`,
      )
        .then((res) => {
          if (res.status == 200) {
            setRows(res.data.result);
            dispatch({
              type: INIT_ORDER,
              payload: res.data.result,
            });
          }
        })
        .catch((e) => {
          dispatch({
            type: SHOW_SNACKBAR,
            payload: {
              message: e.response.message || "Something went wrong",
              type: "error",
            },
          });
        });
    }
  };

  const sendToDetailPage = (id) => {
    history.push(`/${params.mobileNo}/owner/orderdetail?id=${id}`);
  };

  const handleApplyFilters = () => {
    setPage(0);
    setRows([]);
    dispatch({
      type: INIT_ORDER,
      payload: [],
    });
  };

  const handleClearFilters = () => {
    setSalesmanCd("");
    setDistributorCd("");
    setFromDate(null);
    setToDate(null);
    setPage(0);
    setRows([]);
    dispatch({
      type: INIT_ORDER,
      payload: [],
    });
  };

  const handleFromDateChange = (date) => {
    setFromDate(date);
  };

  const handleToDateChange = (date) => {
    setToDate(date);
  };

  // Count active filters
  const getActiveFiltersCount = () => {
    let count = 0;
    if (salesmanCd) count++;
    if (distributorCd) count++;
    if (fromDate) count++;
    if (toDate) count++;
    return count;
  };

  // Flatten orders data to create items view
  const flattenOrdersToItems = (ordersData) => {
    const flattenedItems = [];
    ordersData.forEach((order) => {
      if (order.orderItm && order.orderItm.length > 0) {
        order.orderItm.forEach((item) => {
          flattenedItems.push({
            oitmid: item.oitmid,
            ORDER_NO: order.ORDER_NO,
            orderId: order.orderId,
            ITEM_NAME: item.item?.ITEM_NAME || item.ITEM_NAME || "N/A",
            SIZE_CD: item.SIZE_CD,
            QUANTITY: item.QUANTITY,
            DLVR_QUANTITY: item.DLVR_QUANTITY,
            RATE: item.RATE,
            NET_AMOUNT: item.NET_AMOUNT,
            ISTATUS: item.ISTATUS,
            ACC_NAME: order.accounts?.ACC_NAME || "N/A",
            SMAN_NAME: order.sman?.SMAN_NAME || "-",
            DISTRIBUTOR_NAME: order.accounts?.distributor?.ACC_NAME || "-",
            createdAt: order.createdAt,
            PAYMENT_MODE: order.PAYMENT_MODE,
          });
        });
      }
    });
    return flattenedItems;
  };

  // Handle individual item status change
  const handleIndividualStatusChange = (oitmid, newStatus) => {
    setUpdatingItemId(oitmid);
    Instance.put(`/orders/status?mobileNo=${params.mobileNo}`, {
      id: [oitmid],
      status: newStatus,
      type: "orderitm",
    })
      .then((res) => {
        if (res.status === 200) {
          // Update items data
          const updatedItems = itemsData.map((item) =>
            item.oitmid === oitmid ? { ...item, ISTATUS: newStatus } : item,
          );
          setItemsData(updatedItems);

          // Update orders data
          const updatedRows = rows.map((order) => {
            const updatedOrderItm = order.orderItm.map((item) =>
              item.oitmid === oitmid ? { ...item, ISTATUS: newStatus } : item,
            );
            return { ...order, orderItm: updatedOrderItm };
          });
          setRows(updatedRows);

          dispatch({
            type: SHOW_SNACKBAR,
            payload: {
              message: "Item status updated successfully",
              type: "success",
            },
          });
        }
      })
      .catch((e) => {
        dispatch({
          type: SHOW_SNACKBAR,
          payload: {
            message: "Failed to update item status",
            type: "error",
          },
        });
      })
      .finally(() => {
        setUpdatingItemId(null);
      });
  };

  // Handle bulk status change
  const handleBulkStatusChange = (newStatus) => {
    if (selectedItems.length === 0) return;

    setIsUpdatingStatus(true);
    Instance.put(`/orders/status?mobileNo=${params.mobileNo}`, {
      id: selectedItems,
      status: newStatus,
      type: "orderitm",
    })
      .then((res) => {
        if (res.status === 200) {
          // Update items data
          const updatedItems = itemsData.map((item) =>
            selectedItems.includes(item.oitmid)
              ? { ...item, ISTATUS: newStatus }
              : item,
          );
          setItemsData(updatedItems);

          // Update orders data
          const updatedRows = rows.map((order) => {
            const updatedOrderItm = order.orderItm.map((item) =>
              selectedItems.includes(item.oitmid)
                ? { ...item, ISTATUS: newStatus }
                : item,
            );
            return { ...order, orderItm: updatedOrderItm };
          });
          setRows(updatedRows);

          setSelectedItems([]);
          setSelectAllItems(false);

          dispatch({
            type: SHOW_SNACKBAR,
            payload: {
              message: `${selectedItems.length} item(s) status updated successfully`,
              type: "success",
            },
          });
        }
      })
      .catch((e) => {
        dispatch({
          type: SHOW_SNACKBAR,
          payload: {
            message: "Failed to update item status",
            type: "error",
          },
        });
      })
      .finally(() => {
        setIsUpdatingStatus(false);
      });
  };

  // Handle select all items
  const handleSelectAllItems = (e) => {
    if (e.target.checked) {
      const selectableItems = itemsData
        .filter(
          (item) => item.ISTATUS === "Pending" || item.ISTATUS === "Approved",
        )
        .map((item) => item.oitmid);
      setSelectedItems(selectableItems);
      setSelectAllItems(true);
    } else {
      setSelectedItems([]);
      setSelectAllItems(false);
    }
  };

  // Handle individual item selection
  const handleItemSelection = (oitmid, checked) => {
    if (checked) {
      setSelectedItems([...selectedItems, oitmid]);
    } else {
      setSelectedItems(selectedItems.filter((id) => id !== oitmid));
      setSelectAllItems(false);
    }
  };

  // Build URL with filters
  const buildOrdersUrl = () => {
    let url = getQueryVariable("type")
      ? `/orders/filter?mobileNo=${params.mobileNo}&type=${getQueryVariable(
          "type",
        )}&per_page=${rowsPerPage}&page=${page}`
      : `/orders?mobileNo=${params.mobileNo}&per_page=${rowsPerPage}&page=${page}`;

    if (salesmanCd) url += `&salesmanCd=${salesmanCd}`;
    if (distributorCd) url += `&distributorCd=${distributorCd}`;
    if (fromDate) url += `&fromDate=${moment(fromDate).format("YYYY-MM-DD")}`;
    if (toDate) url += `&toDate=${moment(toDate).format("YYYY-MM-DD")}`;

    return url;
  };

  const { data: resOwnerOrders, error: resOwnerOrdersError } =
    useSWR(buildOrdersUrl());

  const { data: resOwnerOrdersExport, error: resOwnerOrdersExportError } =
    useSWR(
      getQueryVariable("type")
        ? getQueryVariable("type") == "total"
          ? `/orders/export/data?mobileNo=${params.mobileNo}`
          : `/orders/export/data?mobileNo=${
              params.mobileNo
            }&type=${getQueryVariable("type")}`
        : `/orders/export/data?mobileNo=${params.mobileNo}`,
    );

  const [exportData, setExportData] = useState([]);
  const [isLoadingExportData, setIsLoadingExportData] = useState(false);
  const [exportCsv, setExportCsv] = useState(false);
  const headers = [
    { label: "Order Id", key: "ORDER_NO" },
    { label: "Customer Name", key: "ACC_NAME" },
    { label: "Item Amount", key: "ITEM_AMT" },
    { label: "Total Items", key: "NO_OF_ITEM" },
    { label: "Total Amount", key: "NET_AMT" },
    { label: "Payment Mode", key: "PAYMENT_MODE" },
    { label: "Item Name", key: "ITEM_NAME" },
    { label: "Size", key: "SIZE_CD" },
    { label: "Quantity Delivered", key: "DLVR_QUANTITY" },
    { label: "Quantity", key: "QUANTITY" },
    { label: "Rate", key: "RATE" },
    { label: "Net Amount", key: "NET_AMOUNT" },
    { label: "Status", key: "ISTATUS" },
    { label: "Order Date", key: "createdAt" },
  ];

  // const fetchExportData = () => {
  //   Instance.get(`/orders/export/data?mobileNo=${params.mobileNo}`)
  //     .then((res) => {
  //       if (res.status == 200) {
  //         let tempArray = res.data.result;
  //         for (let i = 0; i < res.data.result.length; i++) {
  //           Instance.get(
  //             `/saral/account?accCd=${res.data.result[i].PARTY_CD}&mobileNo=${res.data.result[i].MOBNOCO}`
  //           ).then((res1) => {
  //             if (res1.status == 200) {
  //               tempArray.map((e) => {
  //                 if (e.PARTY_CD == res1.data.result[0].ACC_CD) {
  //                   e.ACC_NAME = res1.data.result[0].ACC_NAME;
  //                   e.ADD1 = res1.data.result[0].ADD1;
  //                   e.ADD2 = res1.data.result[0].ADD2;
  //                   e.AREA = res1.data.result[0].AREA;
  //                   e.CITY = res1.data.result[0].CITY;
  //                   e.PINCODE = res1.data.result[0].PINCODE;
  //                   e.PHONE1 = res1.data.result[0].PHONE1;
  //                   e.PHONE2 = res1.data.result[0].PHONE2;
  //                 }
  //               });
  //               setExportData(tempArray);
  //             }
  //             if (i == tempArray.length - 1) {
  //               setIsLoadingExportData(false);
  //             }
  //           });
  //         }
  //       }
  //     })
  //     .catch((e) => {
  //       setError(e.response.message || "Something went wrong");
  //     });
  // };

  const exportPdf = () => {
    const unit = "pt";
    const size = "A4";
    const orientation = "portrait";

    const marginLeft = 40;
    const doc = new jsPDF(orientation, unit, size);

    doc.setFontSize(15);

    const title = "Orders Report";
    const headers = [
      [
        "Order Id",
        "Customer Name",
        "Payment Mode",
        "Order Date",
        "Total",
        "Item Name",
        "Status",
      ],
    ];

    const data = exportData.map((e) => [
      e.ORDER_NO,
      e.ACC_NAME,
      e.PAYMENT_MODE,
      new Date(e.createdAt).toLocaleString("us-en", {
        dateStyle: "long",
      }),
      e.NET_AMT,
      e.ITEM_NAME,
      e.ISTATUS,
    ]);

    let content = {
      startY: 50,
      head: headers,
      body: data,
    };

    doc.text(title, marginLeft, 40);
    doc.autoTable(content);
    doc.save("orders.pdf");
  };

  // Export selected orders as individual PDF files (one per order)
  const exportSelectedOrdersPdf = () => {
    if (selectedOrders.length === 0) return;
    const selectedRows = rows.filter((r) => selectedOrders.includes(r.orderId));
    if (selectedRows.length === 0) return;
    const companyInfo = globalContext.company?.[0] || {};

    // Generate a separate PDF for each selected order
    selectedRows.forEach((order, index) => {
      // Stagger downloads to avoid browser blocking
      setTimeout(() => {
        exportOrderPdf(order, companyInfo, `Order_${order.ORDER_NO}`);
      }, index * 500);
    });

    setSelectedOrders([]);
    setSelectAllOrders(false);
  };

  // Handle select/deselect all orders
  const handleSelectAllOrders = (e) => {
    if (e.target.checked) {
      setSelectedOrders(rows.map((r) => r.orderId));
      setSelectAllOrders(true);
    } else {
      setSelectedOrders([]);
      setSelectAllOrders(false);
    }
  };

  // Handle individual order selection
  const handleOrderSelection = (orderId, checked) => {
    if (checked) {
      setSelectedOrders([...selectedOrders, orderId]);
    } else {
      setSelectedOrders(selectedOrders.filter((id) => id !== orderId));
      setSelectAllOrders(false);
    }
  };

  useEffect(() => {
    if (resOwnerOrdersExport) {
      setExportData(resOwnerOrdersExport.data.result);
      setIsLoadingExportData(false);
    }
  }, [resOwnerOrdersExport]);

  // useEffect(() => {
  //   dispatch({
  //     type: INIT_ORDER,
  //     payload: [],
  //   });
  //   setRows([]);
  // }, [getQueryVariable("type")]);

  useEffect(() => {
    if (resOwnerOrders) {
      const uniqueArray = (a) =>
        [...new Set(a.map((o) => JSON.stringify(o)))].map((s) => JSON.parse(s));
      const newData = rows.concat(resOwnerOrders.data.result);
      const unique = uniqueArray(newData);
      setRows(unique);
      dispatch({
        type: LOAD_ORDER,
        payload: unique,
      });
      setNextPage(resOwnerOrders.data.pagination.nextPage);
      setPreviousPage(resOwnerOrders.data.pagination.previousPage);
      setTotalItems(resOwnerOrders.data.pagination.totalItems);
    }
  }, [resOwnerOrders]);

  useEffect(() => {
    if (resOwnerOrdersError || resOwnerOrdersExportError) {
      dispatch({
        type: SHOW_SNACKBAR,
        payload: {
          message: "Something went wrong",
          type: "error",
        },
      });
    }
  }, [resOwnerOrdersError, resOwnerOrdersExportError]);

  // Update items data whenever rows change
  useEffect(() => {
    if (rows && rows.length > 0) {
      const flattened = flattenOrdersToItems(rows);
      setItemsData(flattened);
      setItemsPage(0); // Reset pagination when data changes
    } else {
      setItemsData([]);
      setDisplayedItems([]);
    }
  }, [rows]);

  // Update displayed items based on pagination
  useEffect(() => {
    if (itemsData && itemsData.length > 0) {
      const startIndex = 0;
      const endIndex = (itemsPage + 1) * itemsPerPage;
      setDisplayedItems(itemsData.slice(startIndex, endIndex));
    }
  }, [itemsData, itemsPage, itemsPerPage]);

  // Export functions for Items View
  const exportItemsPdf = () => {
    const unit = "pt";
    const size = "A4";
    const orientation = "landscape";

    const marginLeft = 40;
    const doc = new jsPDF(orientation, unit, size);

    doc.setFontSize(15);

    const title = "Items Report";
    const headers = [
      [
        "Order No",
        "Item Name",
        "Size",
        "Customer",
        "Salesman",
        "Distributor",
        "Qty",
        "Rate",
        "Amount",
        "Status",
      ],
    ];

    const data = itemsData.map((e) => [
      e.ORDER_NO,
      e.ITEM_NAME.substring(0, 20),
      e.SIZE_CD,
      e.ACC_NAME.substring(0, 15),
      e.SMAN_NAME,
      e.DISTRIBUTOR_NAME,
      e.QUANTITY,
      e.RATE,
      e.NET_AMOUNT,
      e.ISTATUS,
    ]);

    let content = {
      startY: 50,
      head: headers,
      body: data,
    };

    doc.text(title, marginLeft, 40);
    doc.autoTable(content);
    doc.save("items_report.pdf");
  };

  const itemsExportHeaders = [
    { label: "Order No", key: "ORDER_NO" },
    { label: "Item Name", key: "ITEM_NAME" },
    { label: "Size", key: "SIZE_CD" },
    { label: "Customer Name", key: "ACC_NAME" },
    { label: "Salesman", key: "SMAN_NAME" },
    { label: "Distributor", key: "DISTRIBUTOR_NAME" },
    { label: "Quantity", key: "QUANTITY" },
    { label: "Delivered Qty", key: "DLVR_QUANTITY" },
    { label: "Rate", key: "RATE" },
    { label: "Amount", key: "NET_AMOUNT" },
    { label: "Status", key: "ISTATUS" },
    { label: "Order Date", key: "createdAt" },
  ];

  return (
    <div>
      <OwnerHeader>
        <div className="md:flex items-center justify-between px-3 md:px-4 py-3">
          <div>
            <div className="text-indigo-500 font-semibold text-sm md:text-base">
              Store Management
            </div>
            <div className="text-xl md:text-2xl font-extrabold leading-7 sm:leading-10 truncate mt-1">
              Orders
            </div>
          </div>
          <div className="flex items-center mb-3 mt-2 md:mt-0">
            <Input
              placeholder="Search"
              className="bg-white border-[1px] border-[#3333cc] px-2 py-1 rounded-lg"
              disableUnderline
              value={search}
              onChange={(e) => {
                if (e.target.value == "") {
                  setSearch("");
                } else {
                  setSearch(e.target.value);
                }
              }}
              startAdornment={
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              }
            />
            <Button
              variant="contained"
              disableElevation
              className="ml-2 bg-[#3333cc] text-white"
              onClick={() => {
                history.push(`/${params.mobileNo}/owner/orders?type=search`);
                handleSearch(search);
              }}
            >
              Search
            </Button>
          </div>
        </div>
        <div className="bg-[#F1F5F9] min-h-screen">
          <Container maxWidth="xl" className="pt-2 pb-5">
            <div>
              {/* Filter Section */}
              <Card className="mb-4 shadow-sm">
                <ListItem className="pb-0">
                  <div className="flex items-center justify-between w-full">
                    <div className="flex items-center">
                      <Badge
                        badgeContent={getActiveFiltersCount()}
                        color="secondary"
                        className="mr-2"
                      >
                        <FilterListIcon className="text-indigo-500" />
                      </Badge>
                      <Typography
                        variant="h6"
                        className="text-indigo-500 uppercase font-bold tracking-wider text-xs ml-2"
                      >
                        Advanced Filters
                      </Typography>
                    </div>
                    <Button
                      size="small"
                      onClick={() => setShowFilters(!showFilters)}
                      className="text-indigo-500"
                    >
                      {showFilters ? "Hide" : "Show"}
                    </Button>
                  </div>
                </ListItem>
                {showFilters && (
                  <>
                    <ListItem className="pt-0 pb-2">
                      <Typography
                        variant="h6"
                        className="text-gray-500 uppercase font-bold tracking-wider text-[9px]"
                      >
                        Filter orders by salesman, distributor, or date range
                      </Typography>
                    </ListItem>
                    <div className="px-4 pb-4">
                      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3 mb-3">
                        {/* Salesman Filter */}
                        <Autocomplete
                          id="salesman-filter"
                          options={salesmanList}
                          getOptionLabel={(option) => option.SMAN_NAME || ""}
                          value={
                            salesmanList.find(
                              (s) => s.SMAN_CD === salesmanCd,
                            ) || null
                          }
                          onChange={(_, newValue) => {
                            setSalesmanCd(newValue ? newValue.SMAN_CD : "");
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Salesman"
                              variant="outlined"
                              size="small"
                              placeholder="Select Salesman"
                            />
                          )}
                          className="bg-white"
                        />

                        {/* Distributor Filter */}
                        <Autocomplete
                          id="distributor-filter"
                          options={distributorList}
                          getOptionLabel={(option) => option.ACC_NAME || ""}
                          value={
                            distributorList.find(
                              (d) => d.ACC_CD === distributorCd,
                            ) || null
                          }
                          onChange={(_, newValue) => {
                            setDistributorCd(newValue ? newValue.ACC_CD : "");
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Distributor"
                              variant="outlined"
                              size="small"
                              placeholder="Select Distributor"
                            />
                          )}
                          className="bg-white"
                        />

                        {/* From Date */}
                        <KeyboardDatePicker
                          disableToolbar
                          variant="inline"
                          inputVariant="outlined"
                          format="DD/MM/yyyy"
                          size="small"
                          label="From Date"
                          value={fromDate}
                          onChange={handleFromDateChange}
                          KeyboardButtonProps={{
                            "aria-label": "change from date",
                          }}
                          className="bg-white"
                          clearable
                        />

                        {/* To Date */}
                        <KeyboardDatePicker
                          disableToolbar
                          variant="inline"
                          inputVariant="outlined"
                          format="DD/MM/yyyy"
                          size="small"
                          label="To Date"
                          value={toDate}
                          onChange={handleToDateChange}
                          KeyboardButtonProps={{
                            "aria-label": "change to date",
                          }}
                          className="bg-white"
                          clearable
                        />
                      </div>

                      {/* Action Buttons */}
                      <div className="flex gap-2">
                        <Button
                          variant="contained"
                          disableElevation
                          className="bg-[#3333cc] text-white"
                          onClick={handleApplyFilters}
                          disabled={
                            !salesmanCd &&
                            !distributorCd &&
                            !fromDate &&
                            !toDate
                          }
                        >
                          Apply Filters
                        </Button>
                        <Button
                          variant="outlined"
                          className="border-[#3333cc] text-[#3333cc]"
                          onClick={handleClearFilters}
                          startIcon={<ClearIcon />}
                          disabled={
                            !salesmanCd &&
                            !distributorCd &&
                            !fromDate &&
                            !toDate
                          }
                        >
                          Clear Filters
                        </Button>
                      </div>
                    </div>
                  </>
                )}
              </Card>

              {/* Tabs for Orders View and Items View */}
              <Card className="mb-4 shadow-sm">
                <Tabs
                  value={currentTab}
                  onChange={(e, newValue) => setCurrentTab(newValue)}
                  indicatorColor="primary"
                  textColor="primary"
                  className="border-b"
                >
                  <Tab label="Orders View" className="font-semibold" />
                  <Tab label="Items View" className="font-semibold" />
                </Tabs>
              </Card>

              <div>
                <div className="mb-3 md:flex items-center justify-between mt-2">
                  <div className="overflow-x-scroll flex hide-scroll-bar">
                    {[
                      { label: "Today", key: "today" },
                      { label: "Pending", key: "Pending" },
                      { label: "Canceled", key: "Canceled" },
                      { label: "Dispatched", key: "Dispatched" },
                      { label: "This Week", key: "thisweek" },
                    ].map((item) => (
                      <Chip
                        key={item.label}
                        label={item.label}
                        onClick={(e) => {
                          dispatch({
                            type: INIT_ORDER,
                            payload: [],
                          });
                          setRows([]);
                          if (getQueryVariable("type") == item.key) {
                            history.push(`/${params.mobileNo}/owner/orders`);
                          } else {
                            history.push(
                              `/${params.mobileNo}/owner/orders?type=${item.key}`,
                            );
                          }
                        }}
                        variant={
                          getQueryVariable("type") == item.key
                            ? "default"
                            : "outlined"
                        }
                        className={
                          getQueryVariable("type") == item.key
                            ? "mx-1 bg-[#3333cc] text-white"
                            : "mx-1 border-[#3333cc]"
                        }
                      />
                    ))}
                  </div>
                  <div>
                    {isLoadingExportData ? (
                      <CircularProgress size={30} />
                    ) : (
                      <>
                        {currentTab === 0 ? (
                          // Orders View Export
                          <>
                            <Button
                              variant="outlined"
                              className="text-blue-600 border-[#3333cc] rounded-full mt-2 md:mt-0"
                              startIcon={<SaveAltIcon />}
                            >
                              <CSVLink
                                data={exportData}
                                headers={headers}
                                filename="Orders.csv"
                                className="text-blue-600"
                              >
                                Excel
                              </CSVLink>
                            </Button>
                            <Button
                              variant="outlined"
                              className="text-blue-600 border-[#3333cc] rounded-full mt-2 md:mt-0 ml-2"
                              startIcon={<InsertDriveFileOutlinedIcon />}
                              onClick={() => {
                                exportPdf();
                              }}
                            >
                              PDF
                            </Button>
                            {selectedOrders.length > 0 && (
                              <Button
                                variant="contained"
                                disableElevation
                                className="bg-[#3333cc] text-white rounded-full mt-2 md:mt-0 ml-2"
                                startIcon={<InsertDriveFileOutlinedIcon />}
                                onClick={exportSelectedOrdersPdf}
                              >
                                Export Selected ({selectedOrders.length})
                              </Button>
                            )}
                          </>
                        ) : (
                          // Items View Export
                          <>
                            <Button
                              variant="outlined"
                              className="text-blue-600 border-[#3333cc] rounded-full mt-2 md:mt-0"
                              startIcon={<SaveAltIcon />}
                            >
                              <CSVLink
                                data={itemsData}
                                headers={itemsExportHeaders}
                                filename="Items.csv"
                                className="text-blue-600"
                              >
                                Excel
                              </CSVLink>
                            </Button>
                            <Button
                              variant="outlined"
                              className="text-blue-600 border-[#3333cc] rounded-full mt-2 md:mt-0 ml-2"
                              startIcon={<InsertDriveFileOutlinedIcon />}
                              onClick={() => {
                                exportItemsPdf();
                              }}
                            >
                              PDF
                            </Button>
                          </>
                        )}
                      </>
                    )}
                  </div>
                </div>

                {/* Orders View */}
                {currentTab === 0 && (
                  <>
                    {!resOwnerOrders && rows.length == 0 ? (
                      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6 gap-3">
                        {[
                          "A",
                          "B",
                          "C",
                          "D",
                          "E",
                          "F",
                          "G",
                          "H",
                          "I",
                          "J",
                          "K",
                          "L",
                        ].map((item) => (
                          <div key={item}>
                            <Skeleton
                              animation="wave"
                              variant="rect"
                              className="w-full"
                              height={118}
                            />
                          </div>
                        ))}
                      </div>
                    ) : resOwnerOrders && rows.length == 0 ? (
                      <div className="min-h-[60vh] flex flex-col items-center justify-center text-center">
                        <StorefrontIcon className="text-black text-[12rem]" />
                        <Typography className="text-2xl font-bold text-black">
                          Oops!
                        </Typography>
                        <Typography>No Match Found.</Typography>
                      </div>
                    ) : (
                      <React.Fragment>
                        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6 gap-3">
                          {rows.map((row) => {
                            return (
                              <div
                                className="border border-gray-200 rounded-xl bg-white shadow-sm hover:shadow-md transition-shadow overflow-hidden"
                                key={row.orderId}
                              >
                                {/* Header: Checkbox + Order No + Status Badge */}
                                <div className="flex items-center justify-between px-3 py-2 bg-gray-50 border-b border-gray-100">
                                  <div className="flex items-center gap-1">
                                    <Checkbox
                                      checked={selectedOrders.includes(
                                        row.orderId,
                                      )}
                                      onChange={(e) =>
                                        handleOrderSelection(
                                          row.orderId,
                                          e.target.checked,
                                        )
                                      }
                                      size="small"
                                      style={{ padding: 0 }}
                                    />
                                    <span className="font-bold text-sm text-[#3333cc]">
                                      #{row.ORDER_NO || ""}
                                    </span>
                                  </div>
                                  <span
                                    className={`text-xs font-semibold px-2.5 py-1 rounded-full text-white ${
                                      row.orderItm.find(
                                        (e) => e.ISTATUS == "Pending",
                                      )
                                        ? "bg-[#ff6600]"
                                        : row.orderItm.every(
                                              (e) => e.ISTATUS == "Dispatched",
                                            )
                                          ? "bg-[#049aab]"
                                          : row.orderItm.every(
                                                (e) => e.ISTATUS == "Canceled",
                                              )
                                            ? "bg-red-500"
                                            : row.orderItm.every(
                                                  (e) =>
                                                    e.ISTATUS == "Approved",
                                                )
                                              ? "bg-green-500"
                                              : "bg-[#3333cc]"
                                    }`}
                                  >
                                    {row.orderItm.find(
                                      (e) => e.ISTATUS == "Pending",
                                    )
                                      ? "Pending"
                                      : row.orderItm.every(
                                            (e) => e.ISTATUS == "Dispatched",
                                          )
                                        ? "Dispatched"
                                        : row.orderItm.every(
                                              (e) => e.ISTATUS == "Canceled",
                                            )
                                          ? "Canceled"
                                          : row.orderItm.every(
                                                (e) => e.ISTATUS == "Approved",
                                              )
                                            ? "Approved"
                                            : "Completed"}
                                  </span>
                                </div>

                                {/* Body */}
                                <Link
                                  to={`/${params.mobileNo}/owner/orderdetail?id=${row.orderId}`}
                                  className="block px-3 py-2.5 space-y-1.5"
                                >
                                  <div className="flex justify-between items-center">
                                    <span className="text-xs text-gray-400">
                                      Order Date
                                    </span>
                                    <span className="text-xs font-semibold text-gray-700">
                                      {new Date(row.createdAt).toLocaleString(
                                        "us-en",
                                        {
                                          dateStyle: "long",
                                        },
                                      )}
                                    </span>
                                  </div>
                                  {row.accounts?.ACC_NAME && (
                                    <div className="flex justify-between items-center">
                                      <span className="text-xs text-gray-400">
                                        Customer
                                      </span>
                                      <span className="text-xs font-semibold text-gray-700 truncate ml-2 text-right max-w-[60%]">
                                        {row.accounts.ACC_NAME}
                                      </span>
                                    </div>
                                  )}
                                  {row.sman?.SMAN_NAME && (
                                    <div className="flex justify-between items-center">
                                      <span className="text-xs text-gray-400">
                                        Salesman
                                      </span>
                                      <span className="text-xs font-semibold text-gray-700 truncate ml-2 text-right max-w-[60%]">
                                        {row.sman.SMAN_NAME}
                                      </span>
                                    </div>
                                  )}
                                  {row.PAYMENT_MODE && (
                                    <div className="flex justify-between items-center">
                                      <span className="text-xs text-gray-400">
                                        Payment
                                      </span>
                                      <span className="text-xs font-semibold text-gray-700">
                                        {row.PAYMENT_MODE}
                                      </span>
                                    </div>
                                  )}
                                  {row.orderItm?.length > 0 && (
                                    <div className="flex justify-between items-center">
                                      <span className="text-xs text-gray-400">
                                        Items
                                      </span>
                                      <span className="text-xs font-semibold text-gray-700">
                                        {row.orderItm.length}
                                      </span>
                                    </div>
                                  )}
                                  <div className="flex justify-between items-center pt-1.5 mt-1 border-t border-gray-100">
                                    <span className="text-xs text-gray-400">
                                      Net Amount
                                    </span>
                                    <span className="text-sm font-bold text-gray-900">
                                      ₹{row.NET_AMT}
                                    </span>
                                  </div>
                                </Link>
                              </div>
                            );
                          })}
                        </div>
                        {nextPage ? (
                          <div className="text-center mb-2">
                            <Button
                              variant="contained"
                              className="bg-[#3333cc] text-white"
                              disableElevation
                              onClick={() => {
                                setPage((pr) => pr + 1);
                              }}
                            >
                              Load More
                            </Button>
                          </div>
                        ) : null}
                      </React.Fragment>
                    )}
                  </>
                )}

                {/* Items View */}
                {currentTab === 1 && (
                  <>
                    {!resOwnerOrders && itemsData.length === 0 ? (
                      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6 gap-3">
                        {[
                          "A",
                          "B",
                          "C",
                          "D",
                          "E",
                          "F",
                          "G",
                          "H",
                          "I",
                          "J",
                          "K",
                          "L",
                        ].map((item) => (
                          <div key={item}>
                            <Skeleton
                              animation="wave"
                              variant="rect"
                              className="w-full"
                              height={118}
                            />
                          </div>
                        ))}
                      </div>
                    ) : resOwnerOrders && itemsData.length === 0 ? (
                      <div className="min-h-[60vh] flex flex-col items-center justify-center text-center">
                        <StorefrontIcon className="text-black text-[12rem]" />
                        <Typography className="text-2xl font-bold text-black">
                          No Items Found
                        </Typography>
                        <Typography>No order items to display.</Typography>
                      </div>
                    ) : (
                      <React.Fragment>
                        {/* Bulk Action Buttons */}
                        {selectedItems.length > 0 && (
                          <Card className="mb-3 p-2 bg-blue-50">
                            <div className="flex flex-wrap items-center justify-between gap-2">
                              <Typography className="font-semibold text-sm">
                                {selectedItems.length} item(s) selected
                              </Typography>
                              <div className="flex gap-2">
                                <Button
                                  variant="contained"
                                  size="small"
                                  className="bg-green-400 text-white text-xs py-1"
                                  onClick={() =>
                                    handleBulkStatusChange("Approved")
                                  }
                                  disabled={isUpdatingStatus}
                                  startIcon={
                                    isUpdatingStatus ? (
                                      <CircularProgress
                                        size={12}
                                        color="inherit"
                                      />
                                    ) : null
                                  }
                                >
                                  Approved Item
                                </Button>
                                <Button
                                  variant="contained"
                                  size="small"
                                  className="bg-[#049aab] text-white text-xs py-1"
                                  onClick={() =>
                                    handleBulkStatusChange("Dispatched")
                                  }
                                  disabled={isUpdatingStatus}
                                  startIcon={
                                    isUpdatingStatus ? (
                                      <CircularProgress
                                        size={12}
                                        color="inherit"
                                      />
                                    ) : null
                                  }
                                >
                                  Dispatch Item
                                </Button>
                                <Button
                                  variant="contained"
                                  size="small"
                                  className="bg-red-500 text-white text-xs py-1"
                                  onClick={() =>
                                    handleBulkStatusChange("Canceled")
                                  }
                                  disabled={isUpdatingStatus}
                                  startIcon={
                                    isUpdatingStatus ? (
                                      <CircularProgress
                                        size={12}
                                        color="inherit"
                                      />
                                    ) : null
                                  }
                                >
                                  Cancel Item
                                </Button>
                              </div>
                            </div>
                          </Card>
                        )}

                        {/* Items Table - Compact Version */}
                        <TableContainer
                          component={Paper}
                          className="shadow-sm"
                          style={{
                            overflowX: "hidden",
                            scrollbarWidth: "none",
                            msOverflowStyle: "none",
                          }}
                          sx={{
                            "&::-webkit-scrollbar": {
                              display: "none",
                            },
                          }}
                        >
                          <Table stickyHeader size="small">
                            <TableHead>
                              <TableRow className="grid grid-cols-4 md:grid-cols-9 py-1 bg-gray-200">
                                <TableCell className="border-0 p-1 font-bold text-[10px]">
                                  <Checkbox
                                    size="small"
                                    checked={selectAllItems}
                                    onChange={handleSelectAllItems}
                                    disabled={
                                      !displayedItems.some(
                                        (item) =>
                                          item.ISTATUS === "Pending" ||
                                          item.ISTATUS === "Approved",
                                      )
                                    }
                                  />
                                </TableCell>
                                <TableCell className="border-0 p-1 font-bold text-[10px]">
                                  Order
                                </TableCell>
                                <TableCell className="border-0 p-1 font-bold text-[10px] md:col-span-2">
                                  Item & Size
                                </TableCell>
                                <TableCell className="border-0 p-1 font-bold text-[10px] hidden md:table-cell">
                                  Customer
                                </TableCell>
                                <TableCell className="border-0 p-1 font-bold text-[10px] hidden md:table-cell">
                                  Salesman
                                </TableCell>
                                <TableCell className="border-0 p-1 font-bold text-[10px] hidden md:table-cell">
                                  Distributor
                                </TableCell>
                                <TableCell className="border-0 p-1 font-bold text-[10px]">
                                  Qty/Rate
                                </TableCell>
                                <TableCell className="border-0 p-1 font-bold text-[10px] md:col-span-1">
                                  Status
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {displayedItems.map((item, index) => {
                                const isSelectable =
                                  item.ISTATUS === "Pending" ||
                                  item.ISTATUS === "Approved";
                                return (
                                  <StyledTableRow
                                    key={index}
                                    className="grid grid-cols-4 md:grid-cols-9 py-1 border-t items-center"
                                  >
                                    {/* Checkbox */}
                                    <TableCell className="border-0 p-1 text-[10px]">
                                      {isSelectable && (
                                        <Checkbox
                                          size="small"
                                          checked={selectedItems.includes(
                                            item.oitmid,
                                          )}
                                          onChange={(e) =>
                                            handleItemSelection(
                                              item.oitmid,
                                              e.target.checked,
                                            )
                                          }
                                        />
                                      )}
                                    </TableCell>

                                    {/* Order No */}
                                    <TableCell className="border-0 p-1 text-[10px]">
                                      #{item.ORDER_NO}
                                    </TableCell>

                                    {/* Item & Size */}
                                    <TableCell className="border-0 p-1 text-[10px] md:col-span-2">
                                      <div className="font-semibold leading-tight">
                                        {item.ITEM_NAME.substring(0, 20)}
                                        {item.ITEM_NAME.length > 20
                                          ? "..."
                                          : ""}
                                      </div>
                                      <div className="text-gray-600 text-[9px]">
                                        {item.SIZE_CD}
                                      </div>
                                    </TableCell>

                                    {/* Customer (Hidden on mobile) */}
                                    <TableCell className="border-0 p-1 text-[10px] hidden md:table-cell">
                                      {item.ACC_NAME.substring(0, 12)}
                                    </TableCell>

                                    {/* Salesman (Hidden on mobile) */}
                                    <TableCell className="border-0 p-1 text-[10px] hidden md:table-cell">
                                      {item.SMAN_NAME.substring(0, 10)}
                                    </TableCell>

                                    {/* Distributor (Hidden on mobile) */}
                                    <TableCell className="border-0 p-1 text-[10px] hidden md:table-cell">
                                      {item.DISTRIBUTOR_NAME.substring(0, 10)}
                                    </TableCell>

                                    {/* Quantity & Rate */}
                                    <TableCell className="border-0 p-1 text-[10px]">
                                      <div className="leading-tight">
                                        Q:{item.QUANTITY}
                                      </div>
                                      <div className="leading-tight">
                                        D:{item.DLVR_QUANTITY}
                                      </div>
                                      <div className="text-gray-600 leading-tight">
                                        ₹{item.RATE}
                                      </div>
                                    </TableCell>

                                    {/* Status with Dropdown */}
                                    <TableCell className="border-0 p-1 text-[10px] md:col-span-1">
                                      <FormControl size="small" fullWidth>
                                        <Select
                                          value={item.ISTATUS}
                                          onChange={(e) =>
                                            handleIndividualStatusChange(
                                              item.oitmid,
                                              e.target.value,
                                            )
                                          }
                                          disabled={
                                            !isSelectable ||
                                            updatingItemId === item.oitmid
                                          }
                                          className={"text-[10px]"}
                                          style={{
                                            fontSize: "10px",
                                            padding: "2px",
                                          }}
                                          startAdornment={
                                            updatingItemId === item.oitmid ? (
                                              <InputAdornment position="start">
                                                <CircularProgress size={10} />
                                              </InputAdornment>
                                            ) : null
                                          }
                                        >
                                          <MenuItem
                                            value="Pending"
                                            style={{ fontSize: "11px" }}
                                          >
                                            Pending
                                          </MenuItem>
                                          <MenuItem
                                            value="Approved"
                                            style={{ fontSize: "11px" }}
                                          >
                                            Approved
                                          </MenuItem>
                                          <MenuItem
                                            value="Dispatched"
                                            style={{ fontSize: "11px" }}
                                          >
                                            Dispatched
                                          </MenuItem>
                                          <MenuItem
                                            value="Canceled"
                                            style={{ fontSize: "11px" }}
                                          >
                                            Canceled
                                          </MenuItem>
                                        </Select>
                                      </FormControl>
                                    </TableCell>
                                  </StyledTableRow>
                                );
                              })}
                            </TableBody>
                          </Table>
                        </TableContainer>

                        {/* Load More Button */}
                        {displayedItems.length < itemsData.length && (
                          <div className="text-center mt-3 mb-2">
                            <Button
                              variant="contained"
                              className="bg-[#3333cc] text-white"
                              disableElevation
                              onClick={() => setItemsPage((prev) => prev + 1)}
                            >
                              Load More ({displayedItems.length} of{" "}
                              {itemsData.length})
                            </Button>
                          </div>
                        )}
                      </React.Fragment>
                    )}
                  </>
                )}
              </div>
            </div>
          </Container>
        </div>
      </OwnerHeader>
    </div>
  );
};

export default OwnerViewOrders;
